import {AbstractControl, FormArray, FormControl, FormGroup, ValidatorFn, Validators} from "@angular/forms";
import {ChangeDetectorRef, Component, Input, OnInit, ViewChild} from '@angular/core';
import {ParametroFuncao, ParametroTipo} from "../../../funcao/models/parametro-funcao";
import {CurrencyMaskDirective} from "ng2-currency-mask";
import {HttpClient} from "@angular/common/http";
import {MatCheckbox} from "@angular/material/checkbox";
import {OpcoesParametros} from "./opcoes-parametros";
import {getBackHost} from "../../../util/server-util";

@Component({
    selector: 'parametro-funcao',
    templateUrl: './parametro-funcao.component.html',
    styleUrls: ['./parametro-funcao.component.scss', '../../../shared/form-component.css'],
})
export class ParametroFuncaoComponent implements OnInit {
    @Input() item?: ParametroFuncao;

    @Input() parentForm: FormGroup;

    @Input() parametrosRegra;

    @Input() parametrosPai;
    @Input() isParametrosPaiObrigatorio: boolean;

    @Input() isConsulta;

    parametros: FormGroup = new FormGroup({});

    @ViewChild("checkAllOptions", {static: false}) checkAllOptions: MatCheckbox;

    @ViewChild(CurrencyMaskDirective, {static: false}) currencyDirective: CurrencyMaskDirective;

    formControl: AbstractControl;

    opcoes: OpcoesParametros[] = [];

    itemValue: any = null;

    constructor(
        private readonly httpclient: HttpClient,
        private readonly changeDetector: ChangeDetectorRef) {
    }

    ngOnInit() {
        this.loadComponent();
    }

    loadComponent() {
        let validator = null;

        if (this.item.obrigatorio) {
            validator = Validators.required;
        }

        if (this.item.parametroVinculado !== '') {
            this.parametros.setValidators(this.parametrosVinculadosFormValidation(this.item.variavel, this.item.parametroVinculado));
        }

        if (this.item.tipo !== ParametroTipo.COMPOSTO && this.item.tipo !== ParametroTipo.CHECKBOX) {
            this.formControl = new FormControl(null, validator);
            if (this.item.tipo === ParametroTipo.PERCENTUAL) {
                this.formControl.setValidators([this.valorPercentualMenorCem(), this.valorPercentualMaiorZero()]);
            }
            if (this.item.tipo === ParametroTipo.BOOLEAN) {
                if (this.parametrosRegra)
                    this.formControl.setValue(this.parametrosRegra[this.item.variavel]);
                else
                    this.formControl.setValue(false);
            }
            this.parametros.controls[this.item.variavel] = this.formControl;
        }

        if (this.item.endpointOpcoes && this.item.tipo !== 'MULTI_SELECT' && this.item.tipo !== 'CHECKBOX') {
            this.httpclient.get<OpcoesParametros[]>(getBackHost(this.item.endpointOpcoes)).subscribe(opcoes => {
                this.opcoes = opcoes;
                this.changeDetector.detectChanges();
            });
        }

        this.parentForm.addControl(this.item.variavel, this.parametros);

        if (this.formControl) {
            this.formControl.valueChanges.subscribe(control => {
                this.parametros.updateValueAndValidity({onlySelf: false});
            });
        }

        if (this.parametrosRegra) {
            this.formControlValue();
        }
    }

    formControlValue() {
        if (this.isConsulta) {
            this.formControl?.disable();
        }

        if ([ParametroTipo.MULTI_SELECT, ParametroTipo.COMPOSTO, ParametroTipo.BOOLEAN, ParametroTipo.CHECKBOX].includes(this.item.tipo)) {
            this.itemValue = this.parametrosRegra[this.item.variavel];
        } else {
            if (this.parametrosPai) {
                this.formControl.patchValue(this.parametrosPai[this.item.variavel]);
                this.parentForm.get(this.item.variavel).patchValue(this.formControl);
            } else if (this.item.tipo !== ParametroTipo.COMPOSTO && this.item.tipo !== ParametroTipo.CHECKBOX) {
                this.formControl.patchValue(this.parametrosRegra[this.item.variavel]);
                this.parentForm.get(this.item.variavel).patchValue(this.formControl);
            }
        }
    }

    private valorPercentualMenorCem(): ValidatorFn {
        return (control: FormControl): { [key: string]: any } | null => {
            const valid = (control.value == null || control.value <= 100);
            return valid ? null : {valorMaiorCem: !valid};
        };
    }

    private parametrosVinculadosFormValidation(controlName?: string, anotherControlName?: string): ValidatorFn {
        return (form: FormGroup): { [key: string]: any } | null => {
            const control = form.get(controlName);

            const parentControl = this.parentForm.get(anotherControlName);
            const anotherControl = parentControl ? parentControl.get(anotherControlName) : null;
            const valid = (control && anotherControl) && (control.value !== null || anotherControl.value !== null);
            const error = valid ? null : {parametroVinculadoNaoPreenchido: valid};
            if (anotherControl && this.hasErro(error, anotherControl)) {
                anotherControl.setErrors(error);
                parentControl.setErrors(error);
            }
            if (control && this.hasErro(error, control)) {
                control.setErrors(error);
            }
            return error;
        };
    }

    private hasErro(error: { parametroVinculadoNaoPreenchido: boolean }, control: AbstractControl) {
        return error !== null || !control.hasError('valorMaiorCem') || !control.hasError('valorMenorZero');
    }

    private valorPercentualMaiorZero(): ValidatorFn {
        return (control: FormControl): { [key: string]: any } | null => {
            const valid = (control.value == null || control.value >= 0);
            return valid ? null : {valorMenorZero: !valid};
        };

    }
}


